module.exports = __webpack_public_path__ + "img/customerService.438ba43e.png";